/**
 * This function should be refactored as a composable and moved to `src/composables` folder
 */
export const getTaxTypeName = (isWithTax: boolean): string => {
  return isWithTax
    ? 'performanceCarrefourCatman.salesAmountFormat.TTC'
    : 'performanceCarrefourCatman.salesAmountFormat.HT';
};

export const TAX_VALUES = {
  TTC: 'TTC',
  HT: 'HT'
};
